module.exports = __webpack_public_path__ + "img/noNeeds.c9fbff97.png";